import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const FinalInvitation = () => (
  <section
    className="bg-[#4F5D4F] text-[#F6F1EA] py-16 sm:py-20"
    data-testid="final-invitation-section"
  >
    <div className="max-w-3xl mx-auto px-6 sm:px-8 text-center">
      <p className="text-xs tracking-eyebrow uppercase text-[#D7B2A3] mb-8">The invitation</p>

      <div className="space-y-3 font-serif text-3xl sm:text-4xl lg:text-[42px] leading-[1.25] tracking-tight" data-testid="final-invitation-lines">
        <p>Pause long enough to hear yourself.</p>
        <p>Reclaim what belongs to you.</p>
        <p className="italic text-[#D7B2A3]">
          Become the woman only you get to define.
        </p>
      </div>

      <div className="mt-14 flex items-center justify-center gap-3 sm:gap-5 text-xs tracking-eyebrow uppercase text-[#D7B2A3]">
        <span>Pause</span>
        <span className="w-6 h-px bg-[#D7B2A3]/60" />
        <span>Reclaim</span>
        <span className="w-6 h-px bg-[#D7B2A3]/60" />
        <span>Become</span>
      </div>

      <div className="mt-14 flex flex-wrap items-center justify-center gap-5">
        <Link
          to="/pause-the-spiral"
          className="group inline-flex items-center gap-3 bg-[#F6F1EA] text-[#4F5D4F] hover:bg-[#D7B2A3] px-7 py-4 text-xs tracking-eyebrow uppercase transition-colors"
          data-testid="final-invitation-pause-cta"
        >
          Begin with Pause the Spiral
          <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
        </Link>
        <Link
          to="/booking?package=individual"
          className="text-xs tracking-eyebrow uppercase text-[#F6F1EA] border-b border-[#D7B2A3] hover:text-[#D7B2A3] pb-1 transition-colors"
          data-testid="final-invitation-reclaim-cta"
        >
          Or explore coaching
        </Link>
      </div>
    </div>
  </section>
);

export default FinalInvitation;
